import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
  import Modal from "@/components/ui/Modal.vue";
  import { useToast } from "vue-toastification";
  import DropDown from "../dropdown/DropDown.vue";

  const OTHER_REASON = "Other";

  interface Props {
    isOpen: boolean;
    modalTitle: string;
    reasons: string[];
    canSkip: boolean;
    sendReasonToLead: boolean;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'GiveReasonModal',
  props: {
    isOpen: { type: Boolean },
    modalTitle: {},
    reasons: {},
    canSkip: { type: Boolean },
    sendReasonToLead: { type: Boolean }
  },
  emits: ["close", "confirm", "skip"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;
  const props = __props;

  const toast = useToast();
  const selectedReason = ref<null | string>(null);
  const otherReasonUserInput = ref("");

  const validate = () => {
    const MAX_WORDS_LENGTH = 50;
    const MIN_LETTERS_LENGTH = 5;
    const hasMoreThan50Words =
      otherReasonUserInput.value.trim().split(/\s+/).length > MAX_WORDS_LENGTH;

    return (
      !hasMoreThan50Words &&
      otherReasonUserInput.value.trim().length >= MIN_LETTERS_LENGTH
    );
  };
  const submit = () => {
    const isReasonEmpty = otherReasonUserInput.value.trim().length === 0;

    if (isReasonEmpty && selectedReason.value === null) {
      toast.error("Select a reason");
      return;
    }

    if (selectedReason.value !== OTHER_REASON) {
      emits("confirm", selectedReason.value);
      return;
    }

    if (validate()) {
      emits("confirm", otherReasonUserInput.value.trim());
      return;
    }

    toast.error(
      "Reason must be 50 words or less and have at least 5 letters long."
    );
  };

  const onSkip = () => {
    emits("skip");
  };
  const onClose = () => {
    emits("close");
  };

const __returned__ = { OTHER_REASON, emits, props, toast, selectedReason, otherReasonUserInput, validate, submit, onSkip, onClose, ref, Modal, get useToast() { return useToast }, DropDown }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})